<form (ngSubmit)="findStatistic()" [formGroup]="statisticForm">
    <div style="width: 500px">
        <div class="title">Reports</div>

        <app-alert/>

        <div class="label">Category</div>
        <select class="field" formControlName="category" required>
            <option value="">Choose category...</option>
            <option *ngFor="let category of promoCodeCategories()" [value]="category">
                {{ category }}
            </option>
        </select>

        <div class="label">Batch</div>
        <select class="field" formControlName="batch" required>
            <option value="">Choose batch...</option>
            <option *ngFor="let batch of batches()" [value]="batch.id">
                {{ batch.id }} - {{ batch.description }}
            </option>
        </select>

        <button [disabled]="!statisticForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Get statistic</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../../assets/img/spinner.svg"/>
        </button>

        <div *ngIf="statistic() != null" class="statistic-container">
            <div class="statistic-header">
                <h3>Statistics Report</h3>
            </div>

            <div class="statistic-grid">
                <div class="statistic-card total">
                    <div class="statistic-value">{{ statistic()!.totalCount }}</div>
                    <div class="statistic-label">Total Codes</div>
                </div>

                <div class="statistic-card bound">
                    <div class="statistic-value">{{ statistic()!.boundCount }}</div>
                    <div class="statistic-label">Bound Codes</div>
                </div>

                <div class="statistic-card consumed">
                    <div class="statistic-value">{{ statistic()!.consumedCount }}</div>
                    <div class="statistic-label">Consumed Codes</div>
                </div>
            </div>
        </div>
    </div>
</form>